// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"_2oBnEGzElupx","leg":"_1WDVk8rJ5E36","controls__wrapper":"_2FIrLbD48c8g"};